module.exports = __webpack_public_path__ + "static/media/instrumental.1344e526.svg";